import { render, staticRenderFns } from "./PreLogin.vue?vue&type=template&id=c87a1d92&"
import script from "./PreLogin.vue?vue&type=script&lang=js&"
export * from "./PreLogin.vue?vue&type=script&lang=js&"
import style0 from "./PreLogin.vue?vue&type=style&index=0&id=c87a1d92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports